import React from "react";

/**
 * Exclusive two/three-way toggle. Whichever option is active renders
 * black-with-white-text; the rest stay white-with-black-text. Pass
 * allowDeselect to let clicking the active option clear the selection
 * back to "" (used for Urgent/Immediate, which starts unset).
 */
export default function SegmentedToggle({ options, value, onChange, allowDeselect = false, className = "" }) {
  return (
    <div className={`inline-flex rounded-full border border-slate-200 bg-slate-50 p-0.5 ${className}`}>
      {options.map(opt => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(allowDeselect && active ? "" : opt.value)}
            data-testid={opt.testId}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-all duration-300 ease-out
              ${active ? "bg-black text-white shadow-sm" : "bg-transparent text-slate-600 hover:text-black"}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
